import { __read } from "tslib";
import { VARIABLE_REGEX } from '../constants';
export var extractFormatterType = function (pattern) {
    var variable = pattern.match(VARIABLE_REGEX);
    if (variable) {
        var _a = __read(variable[1].split(';'), 1), variableType = _a[0];
        return variableType;
    }
    return null;
};
